import TabGeneral from './TabGeneral';

export default TabGeneral;
